import React, {useState} from "react";
import AuthenticationModal from "../../../authentication/components/AuthenticationModal";
import useAuthentication from "src/core/authentication/hooks/useAuthentication";
import Modal from "../modules/modal/Modal";
import Loader from "../elements/Loader";

function AuthenticationRequiredComponent({
  children,
  authenticationFailAction,
  onRequestCloseLoad,
}) {
  const [, authApi] = useAuthentication();
  const [authModalOpen, setAuthModalOpen] = useState(!authApi.isLoggedIn());

  const user = authApi.userProfile();

  const displayContent = user || (authApi.isLoggedIn() && !authApi.isValidating());
  return (
    <>
      {displayContent ? (
        children
      ) : (
        <>
          {!authModalOpen && (
            <Modal isOpen={true} onRequestClose={onRequestCloseLoad}>
              <Loader />
            </Modal>
          )}
        </>
      )}
      {authModalOpen && (
        <AuthenticationModal
          isOpen={authModalOpen}
          initialMode={"login"}
          closeModal={() => {
            authenticationFailAction && authenticationFailAction();
            setAuthModalOpen(false);
          }}
          onAuthenticationSuccessful={() => {
            setAuthModalOpen(false);
          }}
        />
      )}
    </>
  );
}

export default AuthenticationRequiredComponent;
